module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ourPartners":"Unsere Partner","new":"Neu","export":"Exportieren","active":"Aktive Partner","inactive":"Inaktive Partner"},"en":{"ourPartners":"Our Partners","new":"New","export":"Export","active":"Active Partners","inactive":"Inactive Partners"}}')
  delete Component.options._Ctor
}
